import React from 'react';
import { BookOpenIcon, CompassIcon, EyeIcon, SparklesIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  compass: CompassIcon,
  book: BookOpenIcon,
  eye: EyeIcon,
  sparkles: SparklesIcon
};
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-party-ink" data-id="element-16" data-mp="3no9j8k73aplo">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="38saar8g2ing0">
        <h2 id="beneficios" className="font-display text-lg font-extrabold leading-tight text-white sm:text-2xl" data-id="element-18" data-mp="38u4wgoz5yjl5">
          ¿Qué puede cambiar cuando empiezas?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-snug text-white/80" data-id="element-19" data-mp="2ztox9rpgdym3">
          Una habilidad creativa puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="y0im3ogsb8ik">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-lg bg-party-charcoal p-2.5 text-left" data-id="element-21" data-mp="2bee19kq7nwe4" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-md bg-party-rose" data-id="element-22" data-mp="2l3nvp78j1r5e">
                  <Icon size={15} className="text-white" data-id="element-23" data-mp="2g6ny7kpqtwpw" />
                </span>
                <div data-id="element-24" data-mp="1sh34q7vyrh2d">
                  <h3 className="font-sans text-[0.8rem] font-extrabold uppercase leading-tight text-party-gold" data-id="element-25" data-mp="1sgl7b7xkewsv">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-[0.76rem] leading-snug text-white/80" data-id="element-26" data-mp="22faikhuyhj05">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}